import {Escola} from "./Escola";
import {Rol} from "./Rol";
import {Portada} from "./Portada";
import {Pagina} from "./Pagina";
import {Notificacio} from "./Notificacio";
import {Configuracio} from "./Configuracio";
import {MenuPantalla} from "./MenuPantalla";

class User {
    constructor(
        public key: number,
        public id: number,
        public value: number,
        public estat: number,
        public nom: string,
        public label: string,
        public escoles: Array<Escola>,
        public rol: Array<Rol>,
        public pagines: Array<Pagina>,
        public portada: Array<Portada>,
        public notificacions: Array<Notificacio>,
        public configuracions: Array<Configuracio>,
        public menus: Array<MenuPantalla>,
        public horaris: Array<any>,
        public empresa: string,
        public nombre: string,
        public cognoms: string,
        public domicili: string,
        public correu: string,
        public iban: string,
        public dni: string,
        public seguretatSocial: string,
        public telefon: string,
        public telefon2: string,
        public naix: string,
        public discapacitat: number,
        public convivencia: number,
        public disciplines: string,
        public pass: string,
        public monitor: string,
        public cv: string,
        public sexuals: string,
        public app: string,
        public ios: string,



    ) {
    }
}

const defaultUser: User = {
    key: 0,
    id: 0,
    value: 0,
    estat: 0,
    nom: "",
    label: "",
    escoles: [],
    pagines: [],
    rol: [],
    portada: [],
    notificacions: [],
    configuracions: [],
    horaris: [],
    menus: [],
    empresa:'',
    nombre:'',
    cognoms:'',
    domicili:'',
    correu: '',
    iban:'',
    dni:'',
    seguretatSocial:'',
    telefon:'',
    telefon2:'',
    naix:'',
    discapacitat:0,
    convivencia:0,
    disciplines:'',
    pass:'',
    monitor:'',
    cv:'',
    sexuals: '',
    app: '',
    ios: '',


};

export {User, defaultUser};
